import { combineReducers } from 'redux';
import { createReducer } from '../../../common/utils/reduxHelpers';

/**
 * REDUCERS
 */
const initialState = {
  settings: [],
};

const settings = createReducer(initialState.settings);

export default combineReducers({
  settings,
});

/**
 * SELECTORS
 */
export const selectSettingsState = state => state.settings;
export const selectSettings = state => selectSettingsState(state).settings;

export const selectSetting = (state, key) => selectSettings(state)[key];
export const selectSettingNumeric = (state, key) => parseFloat(selectSetting(state, key));



// WEBPACK FOOTER //
// ./src/features/settings/ducks/index.js